
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/platform",
      function () {
        return require("private-next-pages/settings/platform.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/platform"])
      });
    }
  